// extracted by mini-css-extract-plugin
export default {"root":"_28B-J"};